import {
  SafetyCertificateOutlined,
  SwapOutlined,
  WalletOutlined,
  HourglassFilled,
  AuditOutlined,
} from "@ant-design/icons";

export const menuItems = [
  {
    key: "1",
    label: "About",
    icon: <SafetyCertificateOutlined />,
    path: "/",
  },
  // {
  //   key: "2",
  //   label: "Portfolio",
  //   icon: <GroupOutlined />,
  //   path: "/portfolio",
  // },
  {
    key: "3",
    label: "Services",
    icon: <SwapOutlined />,
    path: "/services",
  },
  {
    key: "4",
    label: "Projects",
    icon: <AuditOutlined />,
    path: "/projects",
  },
  {
    key: "5",
    label: "Resume",
    icon: <HourglassFilled />,
    path: "/resume",
  },
  {
    key: "5",
    label: "Contact",
    icon: <WalletOutlined />,
    path: "/contact",
  },
];
